<template>
	<div :class="classes">
		<div class="team-list-card-layout__layout-column team-list-card-layout__favorite-column">
			<slot name="favorite"></slot>
		</div>
		<div class="team-list-card-layout__layout-column team-list-card-layout__layout-column--center">
			<div class="team-list-card-layout__layout-column team-list-card-layout__name-column">
				<slot name="name"></slot>
			</div>
			<div class="team-list-card-layout__layout-column team-list-card-layout__leads-column">
				<slot name="leads"></slot>
			</div>
			<div class="team-list-card-layout__layout-column team-list-card-layout__members-column">
				<slot name="members"></slot>
			</div>
		</div>
		<div class="team-list-card-layout__layout-column team-list-card-layout__chevron-column">
			<slot name="chevron"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "TeamListCardLayout",
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"team-list-card-layout": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss">
.team-list-card-layout__leads-column {
	.user-avatar-spread {
		align-items: center;
		display: flex;
		gap: .25rem;
	}
}

.team-list-card-layout__name-column,
.team-list-card-layout__members-column {
	.user-avatar-spread {
		align-items: center;
		display: flex;
		gap: .25rem;
	}
}
</style>

<style lang="scss" scoped>
.team-list-card-layout {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;

	border: 0.0625rem solid transparent;
	border-radius: 0.5rem;
	box-sizing: border-box;

	padding: 0 1rem;
	height: 3.75rem;

	@include for-size('md') {
		padding: 0 1.6025rem;
	}

	@include for-size('xs') {
		height: 6rem;
	}
}

.team-list-card-layout__layout-column {
	display: inline-flex;
	flex-direction: row;
	justify-content: flex-start;
}

.team-list-card-layout__layout-column--center {
	flex: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
}

.team-list-card-layout__favorite-column,
.team-list-card-layout__chevron-column {
	flex: 3rem;
	justify-content: center;
}

.team-list-card-layout__favorite-column {
	flex: 2rem;
	justify-content: flex-start;

	@include for-size('md') {
		flex: 3rem;
		justify-content: center;
	}

	@include for-size-and-smaller('xs') {
		display: none;
	}
}

.team-list-card-layout__chevron-column {
	display: inline-flex;
	@include for-size('xs') {
		flex: 1rem;
		justify-content: flex-end;
	}
}

.team-list-card-layout__name-column,
.team-list-card-layout__leads-column,
.team-list-card-layout__members-column {
	width: 100%;

	@include for-size('sm') {
		width: 50%;
	}

	@include for-size('md') {
		width: 33.33%;
	}
}

.team-list-card-layout__leads-column {
	display: inline-flex;

	@include for-size-and-smaller('sm') {
		display: none;
	}
}

.team-list-card-layout__members-column {
	display: inline-flex;
	justify-content: flex-start;

	@include for-size('xs') {
		justify-content: flex-end;
	}

	@include for-size-and-smaller('xs') {
		display: none;
	}
}
</style>
